// легаси
import { RenamingReducer } from '../modules/renaming/reducers';
import { SearchReducer } from '../modules/search/reducers';

import { Selector } from '@reduxjs/toolkit';
import { FilterReducerShape } from '../../general/modules/filter/reducers';
import { AppShape } from '../modules/app/model';
import { BreadcrumbsShape } from '../modules/breadcrumbs/model';
import { ConflictResolverShape } from '../modules/conflictResolver/model';
import { CreativeConverterShape } from '../modules/creativeConverter/model';
import { CreativeFolderShape } from '../modules/creativeFolder/model';

import { FavoriteShape } from '../modules/favorite/model';
import { Column, FileManagerShape } from '../modules/fileManager/model';
import { MoverShape } from '../modules/mover/model';
import { NewFolderShape } from '../modules/newFolder/model';
import { PermissionModalShape } from '../modules/permissionModal/model';
import { RemoverShape } from '../modules/remover/model';
import { SharedLinksShape } from '../modules/sharedLinks/reducer';
import { SharedLinksRemoverShape } from '../modules/sharedLinksRemover/model';
import { SharingShape } from '../modules/sharing/model';
import { SidebarShape } from '../modules/sidebar/reducer';
import { TagShape } from '../modules/tag/model';
import { TrashShape } from '../modules/trashPage/reducer';
import { UploaderShape } from '../modules/uploader/model';
import { FigmaImportShape } from '../modules/figmaImport/logic';
import { PackerShape } from '../modules/packer/logic';
import { GoogleBulkState } from '../modules/googleBulk/model';
import { VideoMergeState } from '../modules/videoMerge/model';
import { GoogleDriveImportState } from '../modules/googleDriveImport/model';

type EnvShape = {
  forceFullBreadcrumbs?: boolean;
  width?: number;
  height?: number;
};

export type StoreShape = {
  app: AppShape;
  trash: TrashShape;
  breadcrumbs: BreadcrumbsShape;
  creativeFolder: CreativeFolderShape;

  conflictResolver: ConflictResolverShape;
  figmaImport: FigmaImportShape;
  fileManager: FileManagerShape;
  fileManagerFilter: FilterReducerShape<Column>;
  mover: MoverShape;
  newFolder: NewFolderShape;
  packer: PackerShape;
  remover: RemoverShape;
  renaming: ReturnType<typeof RenamingReducer>;
  search: ReturnType<typeof SearchReducer>;
  uploader: UploaderShape;
  favorite: FavoriteShape;
  sharing: SharingShape;
  sharedLinks: SharedLinksShape;
  sharedLinksRemover: SharedLinksRemoverShape;
  sidebar: SidebarShape;
  permissionModal: PermissionModalShape;
  creativeConverter: CreativeConverterShape;
  tag: TagShape;
  env: EnvShape;
  googleBulk: GoogleBulkState;
  videoMerge: VideoMergeState;
  googleDriveImport: GoogleDriveImportState;
};
export type RootSelector<T> = Selector<StoreShape, T>;

export const getStore: RootSelector<StoreShape> = (x: any) => x;
